import { genericFetch } from "./common-service"
import { apiBaseUrl } from "./config"
import { getBaseHeader } from "./utils"
import * as Factory from "./factory"
import * as Model from "../../model"
import { createCommentUpdateRequestBody } from './factory'

const ACCOUNTS = "accounts"
const instructionUrl = `${apiBaseUrl}/instructions`

export function createAccount(
	account: Model.Account,
	instruction: Model.Instruction,
	applyToLocalAuthorities: Model.LocalAuthority[]
): Promise<Model.Account> {
	let url: string = `${instructionUrl}/${instruction.id}/${ACCOUNTS}`

	if (applyToLocalAuthorities.length)
		url += `?${applyToLocalAuthorities.map(l => `applyToLocalAuthorities[]=${l.id}`).join("&")}`

	const headers: HeadersInit = {
		...getBaseHeader(),
		"Content-Type": "application/json"
	}
	const accountRb = Factory.createAccountRequestBody(account)
	const body: string = JSON.stringify(accountRb)
	const init: RequestInit = { body, headers, method: "POST" }

	return genericFetch<Model.Account>(url, init)
}

export function findAccountsByInstruction(
	instruction: Model.Instruction
): Promise<Model.Account[]> {
	const url: string = `${instructionUrl}/${instruction.id}/${ACCOUNTS}`
	const init: RequestInit = {
		headers: getBaseHeader()
	}

	return genericFetch(url, init)
}

export function updateAccount(
	account: Model.Account,
	instruction: Model.Instruction,
	applyToLocalAuthorities: Model.LocalAuthority[] = []
): Promise<Model.Account> {
	let url: string = `${instructionUrl}/${instruction.id}/${ACCOUNTS}/${account.id}`

	if (applyToLocalAuthorities.length)
		url += `?${applyToLocalAuthorities.map(l => `applyToLocalAuthorities[]=${l.id}`).join("&")}`

	const headers: HeadersInit = {
		...getBaseHeader(),
		"Content-Type": "application/json"
	}
	const accountRb = Factory.createAccountRequestBody(account)
	const body: string = JSON.stringify(accountRb)
	const init: RequestInit = { body, headers, method: "PUT" }

	return genericFetch<Model.Account>(url, init)
}

export function updateScenarioComment(id: string, comment: string): Promise<any> {
	const url = `${apiBaseUrl}/scenarios-year-accounts/${id}/comment`
	const uploadFileObject = createCommentUpdateRequestBody(
        comment)
	const init: RequestInit = {
		body: JSON.stringify(uploadFileObject),
		headers: {
			...getBaseHeader(),
			"Content-Type": "application/json"
		},
		method: "PUT"
	}

	return genericFetch(url, init)
}


// WEBPACK FOOTER //
// ./src/service/sfp/accounts-service-2.ts